<template>
    <footer>
        <div class="footer">
            <div class="outer-footer">




                <div class="navigation left-footer">
                    <p class="navigation-title gray-bck">Plan du site</p>
                    <ul>
                        <li>
                            <RouterLink active-class="active-footer-link" class="footer-links" to="/">Accueil
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink active-class="active-footer-link" class="footer-links" to="/a-propos">À propos
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink active-class="active-footer-link" class="footer-links" to="/competences">
                                Compétences</RouterLink>
                        </li>
                        <li>
                            <RouterLink active-class="active-footer-link" class="footer-links" :to="links[rand]">Portfolio
                            </RouterLink>
                        </li>
                    </ul>


                    <a class="cv-download centered footer-cta" href="/files/CV.pdf"
                        download="CV.pdf">
                        <button class="centered">
                            <div>Télécharger Mon CV</div><img class="plus" alt="plus image"
                                src="/img/pictogramme/download.svg">
                        </button>
                    </a>
                </div>




                <div class="middle-footer">
                    <div class="logo-sentence flex-column-center">
                        <RouterLink active-class="active-footer-link" to="/">
                            <img class="logo" width="100" src="/img/am_blanc.png" alt="logo du site web">
                        </RouterLink>
                        <p class="gray">Restons connectés pour ne rien manquer</p>
                    </div>
                </div>





                <div class="navigation right-footer">
                    <p class="navigation-title gray-bck">Contact</p>
                    <ul>
                        <li><u>Téléphone:</u><a class="footer-links" target="_blank" href="tel:0781150636">07 50 57 84 84</a></li>
                        <li><u>E-mail:</u><a class="footer-links" target="_blank" href="mailto:alexandre.meux@etu.u-pec.fr">alexandre.meux@etu.u-pec.fr</a></li>
                        <li><u>LinkedIn:</u><a class="footer-links" target="_blank" href="https://www.linkedin.com/in/alexandre-meux-2ba28a29b/">linkedin.com/in/alexandre-meux</a></li>
                    </ul>
                    <!-- <div class="send-mail flex footer-cta">
                        <input type="text" placeholder="M'envoyer un mail">
                             <button>Envoyer</button>
                    </div> -->
                </div>



                <div class="bottom-footer">
                    <hr>
                    <p class="right-reserved">©Alexandre MEUX – Tous droits réservés | 2025</p>
                </div>



            </div>
        </div>
    </footer>
</template>










<script>

export default {
    name: 'TheFooter',
    data() {
        return {
            rand: null,
            links: [
                '/portfolio/graphisme',
                '/portfolio/audiovisuel',
                '/portfolio/developpement-web',
                '/portfolio/UI-UX',
                '/portfolio/tous'
            ]
        }
    },
    created() {
        this.rand = Math.floor(Math.random() * this.links.length);
    }
}


</script>












<style scoped>
.footer {
    border-top:var(--transparent-gray-border);
    background: var(--hard-blue);
    backdrop-filter: var(--bck-blur);
    box-shadow: 0px 0px 0px 1px var(--gray-hover),0px -6px 20px -4px rgba(0, 0, 0, 0.25);
}

.active-footer-link {
    transition: 0.25s ease-out;
    text-decoration: underline;
    font-weight: 700 !important;
    color:var(--yellow-white);
}


.outer-footer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 4fr 1fr;
    justify-items: center;
    align-items: flex-start;
    padding:2rem .5rem;
}

.footer-links {
    white-space: nowrap;
    font-family: var(--font-text);
    font-size: 1.5rem;
    margin: 0.5rem 0;
}

.bottom-footer {
    grid-row: 2;
    grid-column: 1/4;
    align-self: stretch;
    justify-self: stretch;

}

.middle-footer {
    order: -1;
}

.logo-sentence {
    gap: 2rem;
    margin: 2rem 4rem;
}

.navigation {
    margin: 2rem 4rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.navigation li {
    margin: 0.5rem 0;
}

.right-reserved {
    margin-top: 20px;
    text-align: center !important;
}

.logo-sentence p {
    text-align: center !important;
    text-transform: uppercase;
    color: var(--yellow-white);
    font-weight: 300;
    transition: 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    padding:0 5px;
}

.logo-sentence p:hover {
    font-weight: 600;
}


.footer-cta {
    margin-top: 2rem;
    gap:1rem;
    align-items: flex-end;
    justify-content: center;
    flex-wrap: wrap;
}

.send-cta {
    display: grid;
    place-items: center;
    background: var(--black);
    margin: 0 15px;
    width: 5rem;
    height: 5rem;
    border: var(--light-white-border);
    border-radius: var(--circle-radius);
    transition: 0.15s;
}

.send-cta img {
    filter: brightness(100);
}

.send-cta:hover {
    background: var(--gray);
}

.href {
    transition: 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.navigation-title {
    background: var(--gray);
    padding: 4px 6px;
    margin-bottom: 1.15rem;
    transition: transform 0.2s cubic-bezier(0.47, 0, 0.745, 0.715);
    border-radius: 4px;
    font-size: 1.425rem;
}








/*MEDIA QUERIES*/

@media (max-width:900px) {
    footer .logo {
        width: 80px;
    }
}


@media (max-width:970px) {
    .outer-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}


@media (max-width:600px) {
    footer .logo {
        width: 70px;
    }
}

@media (max-width:400px) {
    footer .logo {
        width: 60px;
    }

    .navigation {
        padding-left: 3vw;
    }
}
</style>